import { render, staticRenderFns } from "./CognitoUsers.vue?vue&type=template&id=32655c92&scoped=true&"
import script from "./CognitoUsers.vue?vue&type=script&lang=js&"
export * from "./CognitoUsers.vue?vue&type=script&lang=js&"
import style0 from "./CognitoUsers.vue?vue&type=style&index=0&id=32655c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32655c92",
  null
  
)

export default component.exports